export default __webpack_public_path__ + "static/media/android.e468d7d6.png";